export default __webpack_public_path__ + "static/media/rating-top-pick-outline.810c1c62.svg";